import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWarranty } from "src/models/Products/Warranty.models";

interface WarrantyState {
  warranties: IWarranty[];
  warrantyToEdit: IWarranty | null;
}

const initialState: WarrantyState = {
  warranties: [],
  warrantyToEdit: null,
};

const warrantySlice = createSlice({
  name: "Warranty",
  initialState,
  reducers: {
    setWarrantyList: (state, action: PayloadAction<IWarranty[]>) => {
      state.warranties = action.payload;
    },
    concatListWarranty: (
      state: WarrantyState,
      action: PayloadAction<IWarranty[]>
    ) => {
      state.warranties = [...state.warranties.concat(action.payload)];
    },
    setWarrantyToEdit: (state, action: PayloadAction<IWarranty | null>) => {
      state.warrantyToEdit = action.payload;
    },
    addWarranty: (state, action: PayloadAction<IWarranty>) => {
      state.warranties.push(action.payload);
    },
    updateWarranty: (state, action: PayloadAction<IWarranty>) => {
      let itemIndex = state.warranties.findIndex(
        item => item.warrantyId === action.payload.warrantyId
      );
      if (itemIndex !== -1) state.warranties[itemIndex] = action.payload;
    },
    deleteWarranty: (state, action: PayloadAction<number>) => {
      const newArray = state.warranties.filter(
        item => item.warrantyId !== action.payload
      );
      state.warranties = newArray;
    },
  },
});

export const {
  setWarrantyList,
  concatListWarranty,
  setWarrantyToEdit,
  addWarranty,
  updateWarranty,
  deleteWarranty,
} = warrantySlice.actions;

export default warrantySlice.reducer;
